module.exports = __webpack_public_path__ + "static/img/Mates_logo.e180f78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/Mates_logo.png
// module id = j0rM
// module chunks = 0